import { z } from 'zod';

const hasNoEmbeddedScheme = (value: string): boolean => !value.includes('://');

// Todo move to ZOD validator library
export const hostPathSchema = z
  .string()
  .min(1)
  .refine(hasNoEmbeddedScheme, { message: 'Must be host/path without scheme (e.g. example.com/graphql)' });

export const httpsUrlSchema = z
  .string()
  .url()
  .refine((value) => value.startsWith('https://'), { message: 'URL must use https://' });

/** Site origin for absolute URLs (canonical, hreflang, Open Graph), e.g. https://catalog.jablotron.com. */
export const siteUrlSchema = httpsUrlSchema.refine((value) => !value.endsWith('/'), {
  message: 'Site URL must not end with a slash',
});

export const wssUrlSchema = z
  .string()
  .url()
  .refine((value) => value.startsWith('wss://'), { message: 'WebSocket URL must use wss://' })
  .refine((value) => !value.includes('://https://') && !value.includes('://http://'), {
    message: 'WebSocket URL must not embed http(s) scheme in the path',
  });

export const environmentKeySchema = z.enum(['development', 'staging', 'production']);

export type EnvironmentKey = z.infer<typeof environmentKeySchema>;

/** Builds validated https + wss GraphQL endpoints from a host/path (no scheme). */
export const graphEndpoints = (hostAndPath: string): { url: string; ws: string } => {
  const hostPath = hostPathSchema.parse(hostAndPath);
  const url = httpsUrlSchema.parse(`https://${hostPath}`);
  const ws = wssUrlSchema.parse(`wss://${hostPath}`);

  return { url, ws };
};
